import React, { useState, Component } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Calendar, Clock, RefreshCw, Info, Lock, CreditCard } from 'lucide-react';
// --- Custom Bespoke SVG Illustrations for Extras ---
const DishwasherIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-691">
    <rect x="12" y="12" width="40" height="40" rx="4" fill="#1B1B2F" data-id="element-692" />
    <rect x="16" y="16" width="32" height="8" rx="2" fill="#2BBCB3" data-id="element-693" />
    <rect x="16" y="28" width="32" height="20" rx="2" fill="#E8F6F5" data-id="element-694" />
    <circle cx="24" cy="38" r="6" fill="#F5C842" data-id="element-695" />
    <circle cx="40" cy="38" r="6" fill="#F5C842" data-id="element-696" />
    <path d="M16 28 L48 28" stroke="#1B1B2F" strokeWidth="2" data-id="element-697" />
  </svg>;
const LaundryIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-698">
    <rect x="14" y="10" width="36" height="44" rx="4" fill="#1B1B2F" data-id="element-699" />
    <rect x="18" y="14" width="28" height="8" rx="2" fill="#2BBCB3" data-id="element-700" />
    <circle cx="32" cy="36" r="12" fill="#E8F6F5" data-id="element-701" />
    <circle cx="32" cy="36" r="8" fill="#2BBCB3" fillOpacity="0.3" data-id="element-702" />
    <circle cx="22" cy="18" r="2" fill="#1B1B2F" data-id="element-703" />
    <circle cx="28" cy="18" r="2" fill="#1B1B2F" data-id="element-704" />
  </svg>;
const OvenIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-705">
    <rect x="12" y="14" width="40" height="40" rx="4" fill="#1B1B2F" data-id="element-706" />
    <rect x="16" y="18" width="32" height="10" rx="2" fill="#2BBCB3" data-id="element-707" />
    <rect x="16" y="32" width="32" height="18" rx="2" fill="#E8F6F5" data-id="element-708" />
    <rect x="22" y="36" width="20" height="10" rx="1" fill="#1B1B2F" data-id="element-709" />
    <circle cx="20" cy="23" r="2" fill="#1B1B2F" data-id="element-710" />
    <circle cx="28" cy="23" r="2" fill="#1B1B2F" data-id="element-711" />
    <circle cx="36" cy="23" r="2" fill="#1B1B2F" data-id="element-712" />
    <circle cx="44" cy="23" r="2" fill="#1B1B2F" data-id="element-713" />
  </svg>;
const FridgeIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-714">
    <rect x="16" y="8" width="32" height="48" rx="4" fill="#1B1B2F" data-id="element-715" />
    <rect x="20" y="12" width="24" height="16" rx="2" fill="#2BBCB3" data-id="element-716" />
    <rect x="20" y="30" width="24" height="22" rx="2" fill="#E8F6F5" data-id="element-717" />
    <rect x="24" y="16" width="2" height="8" fill="#1B1B2F" data-id="element-718" />
    <rect x="24" y="34" width="2" height="12" fill="#1B1B2F" data-id="element-719" />
  </svg>;
const MicrowaveIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-720">
    <rect x="10" y="20" width="44" height="24" rx="4" fill="#1B1B2F" data-id="element-721" />
    <rect x="14" y="24" width="24" height="16" rx="2" fill="#E8F6F5" data-id="element-722" />
    <rect x="42" y="24" width="8" height="16" rx="2" fill="#2BBCB3" data-id="element-723" />
    <rect x="44" y="26" width="4" height="2" fill="#1B1B2F" data-id="element-724" />
    <rect x="44" y="30" width="4" height="2" fill="#1B1B2F" data-id="element-725" />
    <rect x="44" y="34" width="4" height="2" fill="#1B1B2F" data-id="element-726" />
  </svg>;
const CabinetsIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-727">
    <rect x="12" y="12" width="40" height="40" rx="2" fill="#1B1B2F" data-id="element-728" />
    <rect x="14" y="14" width="17" height="36" fill="#2BBCB3" data-id="element-729" />
    <rect x="33" y="14" width="17" height="36" fill="#2BBCB3" data-id="element-730" />
    <rect x="27" y="30" width="2" height="8" fill="#1B1B2F" data-id="element-731" />
    <rect x="35" y="30" width="2" height="8" fill="#1B1B2F" data-id="element-732" />
  </svg>;
const BasementIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-733">
    <path d="M12 12 L32 12 L32 28 L48 28 L48 44 L52 44 L52 52 L12 52 Z" fill="#1B1B2F" data-id="element-734" />
    <rect x="16" y="36" width="12" height="12" rx="2" fill="#F5C842" data-id="element-735" />
    <rect x="36" y="32" width="8" height="8" rx="1" fill="#2BBCB3" data-id="element-736" />
  </svg>;
const FluBusterIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-737">
    <path d="M32 12 C42 12 50 20 50 32 C50 48 32 56 32 56 C32 56 14 48 14 32 C14 20 22 12 32 12 Z" fill="#2BBCB3" data-id="element-738" />
    <path d="M32 20 L32 44 M20 32 L44 32" stroke="#FFFFFF" strokeWidth="4" strokeLinecap="round" data-id="element-739" />
    <circle cx="44" cy="20" r="4" fill="#E85D4A" data-id="element-740" />
    <circle cx="20" cy="44" r="3" fill="#F5C842" data-id="element-741" />
  </svg>;
const BaseboardsIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-742">
    <rect x="12" y="12" width="40" height="32" fill="#E8F6F5" data-id="element-743" />
    <rect x="12" y="44" width="40" height="8" fill="#1B1B2F" data-id="element-744" />
    <path d="M24 36 Q32 28 40 36" stroke="#2BBCB3" strokeWidth="4" strokeLinecap="round" data-id="element-745" />
    <circle cx="40" cy="36" r="4" fill="#F5C842" data-id="element-746" />
  </svg>;
const WindowsIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-747">
    <rect x="16" y="12" width="32" height="40" rx="2" fill="#1B1B2F" data-id="element-748" />
    <rect x="20" y="16" width="10" height="16" fill="#E8F6F5" data-id="element-749" />
    <rect x="34" y="16" width="10" height="16" fill="#E8F6F5" data-id="element-750" />
    <rect x="20" y="34" width="10" height="14" fill="#E8F6F5" data-id="element-751" />
    <rect x="34" y="34" width="10" height="14" fill="#E8F6F5" data-id="element-752" />
    <path d="M20 16 L30 32 M34 16 L44 32" stroke="#2BBCB3" strokeWidth="2" strokeOpacity="0.5" data-id="element-753" />
  </svg>;
const BlindsIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-754">
    <rect x="16" y="12" width="32" height="6" rx="1" fill="#1B1B2F" data-id="element-755" />
    <rect x="18" y="22" width="28" height="4" fill="#2BBCB3" data-id="element-756" />
    <rect x="18" y="30" width="28" height="4" fill="#2BBCB3" data-id="element-757" />
    <rect x="18" y="38" width="28" height="4" fill="#2BBCB3" data-id="element-758" />
    <rect x="18" y="46" width="28" height="4" fill="#2BBCB3" data-id="element-759" />
    <rect x="42" y="18" width="2" height="36" fill="#1B1B2F" data-id="element-760" />
    <circle cx="43" cy="54" r="3" fill="#E85D4A" data-id="element-761" />
  </svg>;
const SheetsIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-762">
    <rect x="12" y="24" width="40" height="20" rx="4" fill="#1B1B2F" data-id="element-763" />
    <rect x="16" y="20" width="14" height="8" rx="2" fill="#F5C842" data-id="element-764" />
    <rect x="34" y="20" width="14" height="8" rx="2" fill="#F5C842" data-id="element-765" />
    <path d="M12 34 L52 34 L52 44 L12 44 Z" fill="#2BBCB3" data-id="element-766" />
    <path d="M12 34 Q32 24 52 34" fill="#E8F6F5" data-id="element-767" />
    <rect x="16" y="44" width="4" height="6" fill="#1B1B2F" data-id="element-768" />
    <rect x="44" y="44" width="4" height="6" fill="#1B1B2F" data-id="element-769" />
  </svg>;
const PropertyCleanupIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-770">
    <path d="M32 12 L12 28 L16 28 L16 48 L48 48 L48 28 L52 28 Z" fill="#1B1B2F" data-id="element-771" />
    <rect x="28" y="36" width="8" height="12" fill="#E8F6F5" data-id="element-772" />
    <path d="M40 32 L46 20 L48 22 L42 34 Z" fill="#F5C842" data-id="element-773" />
    <circle cx="46" cy="20" r="3" fill="#2BBCB3" data-id="element-774" />
    <path d="M18 48 L26 40 L30 48 Z" fill="#E85D4A" data-id="element-775" />
  </svg>;
const PatioIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-776">
    <rect x="12" y="40" width="40" height="8" rx="2" fill="#1B1B2F" data-id="element-777" />
    <rect x="16" y="24" width="4" height="16" fill="#1B1B2F" data-id="element-778" />
    <rect x="28" y="24" width="4" height="16" fill="#1B1B2F" data-id="element-779" />
    <rect x="44" y="24" width="4" height="16" fill="#1B1B2F" data-id="element-780" />
    <rect x="12" y="20" width="40" height="4" rx="1" fill="#1B1B2F" data-id="element-781" />
    <circle cx="32" cy="14" r="6" fill="#F5C842" data-id="element-782" />
    <path d="M26 14 Q32 8 38 14" stroke="#E85D4A" strokeWidth="2" fill="none" data-id="element-783" />
  </svg>;
// --- Main Component ---
export function HomeCleaningForm() {
  // Step 3 State
  const [parking, setParking] = useState('Free on street');
  const [lastCleaning, setLastCleaning] = useState('< 1 month');
  const [pets, setPets] = useState('None');
  const [useSupplies, setUseSupplies] = useState('Yes');
  // Step 4 State (Extras)
  const [selectedExtras, setSelectedExtras] = useState<string[]>([]);
  const toggleExtra = (id: string) => {
    setSelectedExtras(prev => prev.includes(id) ? prev.filter(e => e !== id) : [...prev, id]);
  };
  const extrasList = [{
    id: 'dishwasher',
    label: 'Loading/unloading dishwasher',
    icon: DishwasherIcon
  }, {
    id: 'laundry',
    label: 'Laundry (wash & fold)',
    icon: LaundryIcon
  }, {
    id: 'oven',
    label: 'Inside of oven',
    icon: OvenIcon
  }, {
    id: 'fridge',
    label: 'Inside of fridge',
    icon: FridgeIcon
  }, {
    id: 'microwave',
    label: 'Inside microwave',
    icon: MicrowaveIcon
  }, {
    id: 'cabinets',
    label: 'Interior & Exterior of Kitchen Cabinets',
    icon: CabinetsIcon
  }, {
    id: 'basement',
    label: 'Finished Basement',
    icon: BasementIcon
  }, {
    id: 'flu',
    label: 'Flu Buster - Eucalyptus',
    icon: FluBusterIcon
  }, {
    id: 'baseboards',
    label: 'Hand Wipe Baseboards',
    icon: BaseboardsIcon
  }, {
    id: 'windows',
    label: 'Interior Windows',
    icon: WindowsIcon
  }, {
    id: 'blinds',
    label: 'Wet Wipe Blinds',
    icon: BlindsIcon
  }, {
    id: 'sheets',
    label: 'Change Sheets',
    icon: SheetsIcon
  }, {
    id: 'property',
    label: 'Property Cleanup',
    icon: PropertyCleanupIcon
  }, {
    id: 'patio',
    label: 'Patio or Balcony',
    icon: PatioIcon
  }];
  // Step 5 State
  const [frequency, setFrequency] = useState('Every 2 Weeks');
  // Step 6 State
  const [selectedDate, setSelectedDate] = useState('04/04');
  const [selectedTime, setSelectedTime] = useState('14:00');
  const dates = [{
    day: 'M',
    date: '30/03'
  }, {
    day: 'Tu',
    date: '31/03'
  }, {
    day: 'W',
    date: '01/04'
  }, {
    day: 'Th',
    date: '02/04'
  }, {
    day: 'F',
    date: '03/04'
  }, {
    day: 'Sa',
    date: '04/04'
  }, {
    day: 'Su',
    date: '05/04'
  }];
  // Step 7 State
  const [paymentMethod, setPaymentMethod] = useState('By Credit/Debit Card');
  // Helper for Step Headings
  const StepHeading = ({
    number,
    title,
    subtitle
  }: {
    number: string;
    title: string;
    subtitle?: string;
  }) => <div className="mb-8" data-id="element-784">
      <div className="flex items-center gap-4 mb-2" data-id="element-785">
        <div className="w-10 h-10 rounded-full bg-accent flex items-center justify-center text-white font-heading font-bold text-xl shadow-md shrink-0" data-id="element-786">
          {number}
        </div>
        <h3 className="text-2xl md:text-3xl font-heading font-bold text-primary uppercase tracking-wide" data-id="element-787">
          {title}
        </h3>
      </div>
      {subtitle && <p className="text-gray-500 text-base ml-14 pb-4 border-b border-gray-100" data-id="element-788">
          {subtitle}
        </p>}
      {!subtitle && <div className="ml-14 pb-4 border-b border-gray-100" data-id="element-789"></div>}
    </div>;
  return <main className="min-h-screen bg-light pb-24" data-id="element-790">
      {/* Dark Page Hero */}
      <section className="bg-primary pt-36 md:pt-44 pb-16 md:pb-24 relative overflow-hidden" data-id="element-791">
        <div className="absolute inset-0 opacity-10 pointer-events-none" style={{
        backgroundImage: 'radial-gradient(rgba(255,255,255,0.15) 1px, transparent 1px)',
        backgroundSize: '24px 24px'
      }} data-id="element-792"></div>
        <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-793">
          {/* Breadcrumb */}
          <div className="text-sm font-medium text-white/50 mb-6 uppercase tracking-wider" data-id="element-794">
            <Link to="/" className="hover:text-accent transition-colors" data-id="element-795">
              Home
            </Link>
            <span className="mx-2" data-id="element-796">/</span>
            <Link to="/services" className="hover:text-accent transition-colors" data-id="element-797">
              Our Services
            </Link>
            <span className="mx-2" data-id="element-798">/</span>
            <span className="text-accent" data-id="element-799">Book Online</span>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-800">
            <h1 className="text-5xl md:text-7xl lg:text-8xl font-heading font-bold text-white uppercase leading-none tracking-tight mb-4" data-id="element-801">
              Basic Home Cleaning
            </h1>
            <p className="text-xl md:text-2xl font-serif italic text-white/60" data-id="element-802">
              Book Online in 60 Seconds
            </p>
          </motion.div>
        </div>
      </section>

      {/* Form & Sidebar Container */}
      <div className="container mx-auto px-6 md:px-12 -mt-8 relative z-20" data-id="element-803">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start" data-id="element-804">
          {/* Main Form Area */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="lg:col-span-8 xl:col-span-9 bg-white rounded-2xl shadow-xl p-8 md:p-12 border border-gray-100" data-id="element-805">
            <div className="text-center mb-16 flex flex-col items-center" data-id="element-806">
              <div className="w-24 h-24 rounded-full border-2 border-accent/20 flex items-center justify-center mb-6 bg-accent/5" data-id="element-807">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#2BBCB3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-808">
                  <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" data-id="element-809"></path>
                  <polyline points="9 22 9 12 15 12 15 22" data-id="element-810"></polyline>
                </svg>
              </div>
              <h2 className="text-3xl md:text-5xl font-heading font-bold text-primary uppercase tracking-wide mb-3" data-id="element-811">
                Home Cleaning
              </h2>
              <p className="text-gray-500 text-lg max-w-2xl mx-auto" data-id="element-812">
                It only takes 60 seconds to Book your Home Cleaning!
              </p>
            </div>

            <form className="space-y-20" onSubmit={e => e.preventDefault()} data-id="element-813">
              {/* STEP 1 */}
              <section data-id="element-814">
                <StepHeading number="1" title="Your contact information." data-id="element-815" />
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 ml-0 md:ml-14" data-id="element-816">
                  <input type="text" placeholder="First Name" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-817" />
                  <input type="text" placeholder="Last Name" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-818" />
                  <input type="email" placeholder="Email" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-819" />
                  <div className="flex rounded-xl border border-gray-200 bg-gray-50 focus-within:bg-white focus-within:ring-2 focus-within:ring-accent focus-within:border-accent transition-all overflow-hidden" data-id="element-820">
                    <div className="px-4 py-4 border-r border-gray-200 bg-gray-100 flex items-center justify-center text-gray-600 font-medium" data-id="element-821">
                      🇬🇧 ▾
                    </div>
                    <input type="tel" placeholder="Phone Number" className="w-full px-5 py-4 outline-none bg-transparent text-primary" data-id="element-822" />
                  </div>
                </div>
              </section>

              {/* STEP 2 */}
              <section data-id="element-823">
                <StepHeading number="2" title="Location of the home to be cleaned." data-id="element-824" />
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 ml-0 md:ml-14" data-id="element-825">
                  <input type="text" placeholder="Enter a location" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-826" />
                  <input type="text" placeholder="Unit/Apt/Suite #" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-827" />
                  <input type="text" placeholder="City" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-828" />
                  <input type="text" placeholder="Postal Code" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-829" />
                </div>
                <div className="ml-0 md:ml-14 mt-4" data-id="element-830">
                  <a href="#" className="text-accent hover:text-primary transition-colors flex items-center gap-2 font-medium" data-id="element-831">
                    See what's included in our base Home Cleaning service{' '}
                    <Info size={16} data-id="element-832" />
                  </a>
                </div>
              </section>

              {/* STEP 3 */}
              <section data-id="element-833">
                <StepHeading number="3" title="Tell us about the cleaning" data-id="element-834" />
                <div className="space-y-8 ml-0 md:ml-14" data-id="element-835">
                  <div data-id="element-836">
                    <label className="text-primary font-medium block mb-3 text-lg" data-id="element-837">
                      How many hours and cleaners would you like to book?
                    </label>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-838">
                      <select className="w-full px-5 py-3.5 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary appearance-none cursor-pointer" data-id="element-839">
                        <option data-id="element-840">2 Hours</option>
                        <option data-id="element-841">3 Hours</option>
                        <option data-id="element-842">4 Hours</option>
                        <option data-id="element-843">5 Hours</option>
                        <option data-id="element-844">6 Hours</option>
                        <option data-id="element-845">7 Hours</option>
                        <option data-id="element-846">8 Hours</option>
                      </select>
                      <select className="w-full px-5 py-3.5 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary appearance-none cursor-pointer" data-id="element-847">
                        <option data-id="element-848">1 Cleaner</option>
                        <option data-id="element-849">2 Cleaners</option>
                        <option data-id="element-850">3 Cleaners</option>
                      </select>
                    </div>
                  </div>

                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 p-4 rounded-xl hover:bg-gray-50 transition-colors border border-transparent hover:border-gray-100" data-id="element-851">
                    <label className="text-primary font-medium text-lg" data-id="element-852">
                      Bedrooms
                    </label>
                    <select className="w-full sm:w-48 px-4 py-3 rounded-xl border border-gray-200 bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary font-medium appearance-none cursor-pointer shadow-sm" data-id="element-853">
                      <option data-id="element-854">Studio / 1 Bedroom</option>
                      <option data-id="element-855">2 Bedrooms</option>
                      <option data-id="element-856">3 Bedrooms</option>
                      <option data-id="element-857">4 Bedrooms</option>
                      <option data-id="element-858">5+ Bedrooms</option>
                    </select>
                  </div>

                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 p-4 rounded-xl hover:bg-gray-50 transition-colors border border-transparent hover:border-gray-100" data-id="element-859">
                    <label className="text-primary font-medium text-lg" data-id="element-860">
                      Bathrooms
                    </label>
                    <select className="w-full sm:w-48 px-4 py-3 rounded-xl border border-gray-200 bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary font-medium appearance-none cursor-pointer shadow-sm" data-id="element-861">
                      <option data-id="element-862">1 Bathroom</option>
                      <option data-id="element-863">2 Bathrooms</option>
                      <option data-id="element-864">3 Bathrooms</option>
                      <option data-id="element-865">4+ Bathrooms</option>
                    </select>
                  </div>

                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 p-4 rounded-xl hover:bg-gray-50 transition-colors border border-transparent hover:border-gray-100" data-id="element-866">
                    <label className="text-primary font-medium text-lg" data-id="element-867">
                      Additional Rooms (dining room, living room, office, etc)
                    </label>
                    <select className="w-full sm:w-48 px-4 py-3 rounded-xl border border-gray-200 bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary font-medium appearance-none cursor-pointer shadow-sm" data-id="element-868">
                      <option data-id="element-869">No additional rooms</option>
                      <option data-id="element-870">1 Room</option>
                      <option data-id="element-871">2 Rooms</option>
                      <option data-id="element-872">3 Rooms</option>
                      <option data-id="element-873">4+ Rooms</option>
                    </select>
                  </div>

                  <div data-id="element-874">
                    <label className="text-primary font-medium block mb-3 text-lg" data-id="element-875">
                      Parking
                    </label>
                    <div className="flex flex-wrap rounded-xl overflow-hidden border border-gray-200 shadow-sm w-full" data-id="element-876">
                      {['Free on street', 'Free home parking', 'Parking meters', 'Paid parking lot'].map(opt => <button key={opt} type="button" onClick={() => setParking(opt)} className={`flex-1 min-w-[140px] py-3.5 px-4 text-sm font-medium transition-all duration-300 ${parking === opt ? 'bg-accent text-white shadow-inner' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'} border-r border-b sm:border-b-0 border-gray-200 last:border-r-0`} data-id="element-877">
                          {opt}
                        </button>)}
                    </div>
                  </div>

                  <div data-id="element-878">
                    <label className="text-primary font-medium block mb-3 text-lg" data-id="element-879">
                      When was your last full cleaning?
                    </label>
                    <div className="flex rounded-xl overflow-hidden border border-gray-200 shadow-sm w-full max-w-md" data-id="element-880">
                      {['< 1 month', "I'm too embarrassed to say"].map(opt => <button key={opt} type="button" onClick={() => setLastCleaning(opt)} className={`flex-1 py-3.5 px-4 text-sm font-medium transition-all duration-300 ${lastCleaning === opt ? 'bg-accent text-white shadow-inner' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'} border-r border-gray-200 last:border-r-0`} data-id="element-881">
                            {opt}
                          </button>)}
                    </div>
                  </div>

                  <div data-id="element-882">
                    <label className="text-primary font-medium block mb-3 text-lg" data-id="element-883">
                      Do you have any pets? (Required for safety & allergy
                      reasons)
                    </label>
                    <div className="flex rounded-xl overflow-hidden border border-gray-200 shadow-sm w-full max-w-sm" data-id="element-884">
                      {['None', 'Dog', 'Cat'].map(opt => <button key={opt} type="button" onClick={() => setPets(opt)} className={`flex-1 py-3.5 px-4 text-sm font-medium transition-all duration-300 ${pets === opt ? 'bg-accent text-white shadow-inner' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'} border-r border-gray-200 last:border-r-0`} data-id="element-885">
                          {opt}
                        </button>)}
                    </div>
                  </div>

                  <div data-id="element-886">
                    <label className="text-primary font-medium block mb-3 text-lg" data-id="element-887">
                      All cleaning supplies are included at no extra charge.
                      Would you prefer we use yours?
                    </label>
                    <div className="flex rounded-xl overflow-hidden border border-gray-200 shadow-sm w-full max-w-[200px]" data-id="element-888">
                      {['Yes', 'No'].map(opt => <button key={opt} type="button" onClick={() => setUseSupplies(opt)} className={`flex-1 py-3.5 px-4 text-sm font-bold transition-all duration-300 ${useSupplies === opt ? 'bg-accent text-white shadow-inner' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'} border-r border-gray-200 last:border-r-0`} data-id="element-889">
                          {opt}
                        </button>)}
                    </div>
                  </div>
                </div>
              </section>

              {/* STEP 4 */}
              <section data-id="element-890">
                <StepHeading number="4" title="Any Extras?" subtitle="Free up more of your precious time for what matters most!" data-id="element-891" />
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 ml-0 md:ml-14" data-id="element-892">
                  {extrasList.map(({
                  id,
                  label,
                  icon: Icon
                }) => {
                  const isSelected = selectedExtras.includes(id);
                  return <button key={id} type="button" onClick={() => toggleExtra(id)} className={`flex flex-col items-center justify-center p-6 rounded-2xl border-2 transition-all duration-300 group ${isSelected ? 'border-accent bg-accent/5 shadow-md' : 'border-gray-100 bg-gray-50 hover:border-accent/30 hover:bg-gray-100'}`} data-id="element-893">
                        <div className={`mb-4 transform transition-transform duration-300 ${isSelected ? 'scale-110' : 'group-hover:scale-105'}`} data-id="element-894">
                          <Icon data-id="element-895" />
                        </div>
                        <span className={`text-sm text-center font-medium ${isSelected ? 'text-primary font-bold' : 'text-gray-600'}`} data-id="element-896">
                          {label}
                        </span>
                      </button>;
                })}
                </div>
              </section>

              {/* STEP 5 */}
              <section data-id="element-897">
                <StepHeading number="5" title="How often would you like us to clean?" subtitle="Save up to 15% on the Base Cleaning." data-id="element-898" />
                <div className="ml-0 md:ml-14" data-id="element-899">
                  <div className="flex flex-wrap rounded-xl overflow-hidden border border-gray-200 shadow-sm w-full" data-id="element-900">
                    {['One time', 'Weekly', 'Every 2 Weeks', 'Every 4 Weeks'].map(opt => <button key={opt} type="button" onClick={() => setFrequency(opt)} className={`flex-1 min-w-[120px] py-4 px-4 text-sm font-medium transition-all duration-300 ${frequency === opt ? 'bg-accent text-white shadow-inner' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'} border-r border-b sm:border-b-0 border-gray-200 last:border-r-0`} data-id="element-901">
                        {opt}
                      </button>)}
                  </div>
                </div>
              </section>

              {/* STEP 6 */}
              <section data-id="element-902">
                <StepHeading number="6" title="Pick a date for the cleaning." subtitle="For recurring services, each one will commence on the same day and time as selected for the first service." data-id="element-903" />
                <div className="ml-0 md:ml-14 space-y-8" data-id="element-904">
                  <div className="flex flex-col items-center justify-center bg-gray-50 p-6 rounded-xl border border-gray-100" data-id="element-905">
                    <span className="font-bold text-primary mb-3" data-id="element-906">
                      Choose a timezone
                    </span>
                    <div className="flex items-center gap-3" data-id="element-907">
                      <span className="text-gray-500 text-sm" data-id="element-908">
                        Our Company's
                      </span>
                      <div className="w-12 h-6 bg-accent rounded-full relative cursor-pointer" data-id="element-909">
                        <div className="absolute right-1 top-1 w-4 h-4 bg-white rounded-full" data-id="element-910"></div>
                      </div>
                      <span className="text-primary font-medium text-sm" data-id="element-911">
                        Yours
                      </span>
                    </div>
                  </div>

                  <div className="border border-gray-200 rounded-xl overflow-hidden shadow-sm" data-id="element-912">
                    <div className="flex justify-between items-center p-4 border-b border-gray-200 bg-gray-50" data-id="element-913">
                      <button type="button" className="text-gray-400 hover:text-accent transition-colors" data-id="element-914">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-915">
                          <circle cx="12" cy="12" r="10" data-id="element-916"></circle>
                          <polyline points="12 8 8 12 12 16" data-id="element-917"></polyline>
                          <line x1="16" y1="12" x2="8" y2="12" data-id="element-918"></line>
                        </svg>
                      </button>
                      <div className="flex gap-2 sm:gap-6 overflow-x-auto px-2 hide-scrollbar" data-id="element-919">
                        {dates.map(d => <button key={d.date} type="button" onClick={() => setSelectedDate(d.date)} className={`flex flex-col items-center p-2 rounded-lg min-w-[60px] transition-colors ${selectedDate === d.date ? 'bg-accent/10 text-accent' : 'hover:bg-gray-100 text-gray-600'}`} data-id="element-920">
                            <span className="text-sm font-medium mb-1" data-id="element-921">
                              {d.day}
                            </span>
                            <span className="text-xs flex items-center gap-1" data-id="element-922">
                              <Calendar size={12} data-id="element-923" />
                              {d.date}
                            </span>
                          </button>)}
                      </div>
                      <button type="button" className="text-gray-400 hover:text-accent transition-colors" data-id="element-924">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-925">
                          <circle cx="12" cy="12" r="10" data-id="element-926"></circle>
                          <polyline points="12 16 16 12 12 8" data-id="element-927"></polyline>
                          <line x1="8" y1="12" x2="16" y2="12" data-id="element-928"></line>
                        </svg>
                      </button>
                    </div>

                    <div className="p-6 bg-white flex flex-col items-end gap-3" data-id="element-929">
                      {['14:00', '14:30', '15:00'].map(time => <button key={time} type="button" onClick={() => setSelectedTime(time)} className={`flex items-center gap-2 px-6 py-2 rounded-full border transition-all ${selectedTime === time ? 'border-accent bg-accent text-white shadow-md' : 'border-gray-200 text-accent hover:border-accent hover:bg-accent/5'}`} data-id="element-930">
                          <Clock size={16} data-id="element-931" />
                          {time}
                        </button>)}
                    </div>
                  </div>

                  <p className="text-gray-500 text-sm italic" data-id="element-932">
                    For same day bookings, a Customer service agent will call
                    you.
                  </p>

                  <div data-id="element-933">
                    <label className="text-primary font-medium block mb-3 text-lg" data-id="element-934">
                      Are there any additional details we need to know?
                    </label>
                    <textarea className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all min-h-[120px] text-primary resize-y" data-id="element-935"></textarea>
                  </div>
                </div>
              </section>

              {/* STEP 7 */}
              <section data-id="element-936">
                <StepHeading number="7" title="Payment details" subtitle="Select your method of payment. Card charges may be pre-authorized, but applied only after the service event is complete." data-id="element-937" />
                <div className="ml-0 md:ml-14 space-y-6" data-id="element-938">
                  <div className="flex flex-wrap rounded-xl overflow-hidden border border-gray-200 shadow-sm w-full" data-id="element-939">
                    {['By Cash', 'By Check', 'By Credit/Debit Card', 'By Interac e-Transfer'].map(opt => <button key={opt} type="button" onClick={() => setPaymentMethod(opt)} className={`flex-1 min-w-[150px] py-4 px-4 text-sm font-medium transition-all duration-300 ${paymentMethod === opt ? 'bg-accent text-white shadow-inner' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'} border-r border-b sm:border-b-0 border-gray-200 last:border-r-0`} data-id="element-940">
                        {opt}
                      </button>)}
                  </div>

                  {paymentMethod === 'By Credit/Debit Card' && <motion.div initial={{
                  opacity: 0,
                  height: 0
                }} animate={{
                  opacity: 1,
                  height: 'auto'
                }} className="space-y-4" data-id="element-941">
                      <input type="text" placeholder="name on credit card" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-942" />

                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-943">
                        <button type="button" className="flex items-center gap-3 p-4 rounded-xl border-2 border-accent bg-accent/5 text-primary font-medium" data-id="element-944">
                          <CreditCard className="text-accent" data-id="element-945" />
                          Card
                        </button>
                        <button type="button" className="flex items-center gap-3 p-4 rounded-xl border border-gray-200 bg-white hover:bg-gray-50 text-primary font-medium transition-colors" data-id="element-946">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-947">
                            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="#F5C842" data-id="element-948" />
                            <path d="M15 10.5H9V13.5H15V10.5Z" fill="#1B1B2F" data-id="element-949" />
                          </svg>
                          Google Pay
                        </button>
                      </div>

                      <div className="flex items-center gap-2 text-accent text-sm font-bold mt-2" data-id="element-950">
                        <Lock size={14} data-id="element-951" />
                        Secure, fast checkout with Link
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-952">
                          <polyline points="6 9 12 15 18 9" data-id="element-953"></polyline>
                        </svg>
                      </div>

                      <div className="grid grid-cols-1 sm:grid-cols-12 gap-4" data-id="element-954">
                        <div className="sm:col-span-6 relative" data-id="element-955">
                          <input type="text" placeholder="Card number" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-956" />
                          <div className="absolute right-4 top-1/2 -translate-y-1/2 flex gap-1" data-id="element-957">
                            <div className="w-8 h-5 bg-blue-800 rounded flex items-center justify-center text-[8px] text-white font-bold" data-id="element-958">
                              VISA
                            </div>
                            <div className="w-8 h-5 bg-orange-500 rounded flex items-center justify-center text-[8px] text-white font-bold" data-id="element-959">
                              MC
                            </div>
                          </div>
                        </div>
                        <input type="text" placeholder="Expiration date" className="sm:col-span-3 w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-960" />
                        <input type="text" placeholder="Security code" className="sm:col-span-3 w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-961" />
                      </div>

                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-962">
                        <select className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary appearance-none cursor-pointer" data-id="element-963">
                          <option data-id="element-964">United Kingdom</option>
                          <option data-id="element-965">United States</option>
                          <option data-id="element-966">Canada</option>
                        </select>
                        <input type="text" placeholder="Postal Code" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-967" />
                      </div>

                      <p className="text-xs text-gray-500 mt-4 leading-relaxed" data-id="element-968">
                        By providing your card information, you allow Smith and
                        Jengs Cleaning Services to charge your card for future
                        payments in accordance with their terms.
                      </p>
                      <p className="text-xs text-gray-400 text-center italic mt-2" data-id="element-969">
                        I authorize the operator to send instructions to the
                        financial institution that issued my card to take
                        payments from my card account in accordance with the
                        terms of my agreement with you.
                      </p>
                    </motion.div>}

                  <div className="space-y-3 pt-6 flex flex-col items-center" data-id="element-970">
                    <label className="flex items-center gap-3 cursor-pointer group" data-id="element-971">
                      <div className="w-5 h-5 rounded border border-gray-300 flex items-center justify-center group-hover:border-accent transition-colors" data-id="element-972">
                        <div className="w-3 h-3 bg-transparent rounded-sm" data-id="element-973"></div>
                      </div>
                      <span className="text-primary text-lg" data-id="element-974">
                        I would like to be notified by email.
                      </span>
                    </label>
                    <label className="flex items-center gap-3 cursor-pointer group" data-id="element-975">
                      <div className="w-5 h-5 rounded border border-gray-300 flex items-center justify-center group-hover:border-accent transition-colors" data-id="element-976">
                        <div className="w-3 h-3 bg-transparent rounded-sm" data-id="element-977"></div>
                      </div>
                      <span className="text-primary text-lg" data-id="element-978">
                        I would like to be notified by text message.
                      </span>
                    </label>
                  </div>
                </div>
              </section>

              {/* Submit */}
              <div className="pt-12 pb-4 flex justify-center border-t border-gray-100" data-id="element-979">
                <button type="submit" className="bg-[#5CB85C] hover:bg-[#4cae4c] text-white px-16 py-4 rounded text-xl font-bold transition-all shadow-md hover:shadow-lg" data-id="element-980">
                  Book Now
                </button>
              </div>
            </form>
          </motion.div>

          {/* Sidebar - Booking Summary */}
          <div className="lg:col-span-4 xl:col-span-3" data-id="element-981">
            <div className="sticky top-32 bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden" data-id="element-982">
              <div className="bg-gray-50 p-6 border-b border-gray-100" data-id="element-983">
                <h3 className="text-xl font-heading font-bold text-primary uppercase tracking-wide" data-id="element-984">
                  Booking Summary
                </h3>
              </div>

              <div className="p-6 space-y-4 border-b border-gray-100" data-id="element-985">
                <div className="flex items-center gap-3 text-gray-600 text-sm" data-id="element-986">
                  <Calendar size={16} className="text-accent" data-id="element-987" />
                  <span data-id="element-988">4 Apr 2026</span>
                </div>
                <div className="flex items-center gap-3 text-gray-600 text-sm" data-id="element-989">
                  <Clock size={16} className="text-accent" data-id="element-990" />
                  <span data-id="element-991">14:00</span>
                </div>
                <div className="flex items-center gap-3 text-gray-600 text-sm" data-id="element-992">
                  <RefreshCw size={16} className="text-accent" data-id="element-993" />
                  <span data-id="element-994">Every 2 Weeks</span>
                </div>
              </div>

              <div className="p-6 space-y-3 border-b border-gray-100 text-sm" data-id="element-995">
                <div className="flex justify-between text-gray-600" data-id="element-996">
                  <span data-id="element-997">Home Cleaning</span>
                  <span data-id="element-998">£40.00</span>
                </div>
                <div className="flex justify-between text-gray-600" data-id="element-999">
                  <span data-id="element-1000">DISCOUNTS</span>
                  <span data-id="element-1001">£0.00</span>
                </div>
                <div className="flex justify-between text-gray-600" data-id="element-1002">
                  <span data-id="element-1003">EXTRAS</span>
                  <span data-id="element-1004">£0.00</span>
                </div>
              </div>

              <div className="p-6 bg-gray-50 flex justify-between items-center" data-id="element-1005">
                <span className="font-bold text-primary text-lg" data-id="element-1006">TOTAL</span>
                <span className="font-bold text-primary text-lg" data-id="element-1007">£40.00</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>;
}